import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { BreadCrumbs } from "../../../shared/breadCrumbs/BreadCrumbs";
import { useNavigate } from "react-router";
import { Link, useLocation } from "react-router-dom";
import { AssetDropDown } from "../../../UiComponents/AssetDropDown";
import { getAsset } from "../../../actions/assetAction";
import { getAssestListddlAction } from "../../../actions/assetsddlAction";
import { getAssetSettings } from "../../../actions/assetSettingsAction";
import { UrlPath } from "../../../../config/routeConfig";
import { TopBar } from "../../../shared/topBar/TopBar";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import {PrivateCharts} from './Charts';
import { Data } from "./Data";
import Configuration from "./Configuration";
import { sbaAxios } from "../../../utils/sbaAxios";
import { getUserPageAccess } from "../../../../config/apiConfig";
import { ToastContainer } from "react-toastify";
import { Mapping } from "./Mapping";
export const PrivateExposure = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const history = useNavigate();
  const [render, setRender] = useState(true);
  const [Loading, setLoading] = useState(true);
  const locationData = useLocation();
  const [selectedTab,setSelectedTab]=useState('Charts');
 
  useEffect(() => {
    document.title = "Private Exposure";
    // dispatch(getAssestListddlAction());
    // dispatch(getAsset(params.Asset));
    // dispatch(getAssetSettings(params.Asset));
  }, [render]);

  const Gstate =
    useSelector((state) => {
      return state;
    }) || {};

  useEffect(() => {
    currentAsset && AssetListDDL && setLoading(false);
  }, [Gstate]);

  const AssetListDDL = Gstate.assetDDL.assetList || [];

  const currentAsset = Gstate.asset.asset || {};

  let Level = ([{ BreadCrumb: "Asset >", Routes: `${UrlPath.Asset}`}]);
  Level = Loading
    ? Level
    : [
        ...Level,
        {
          BreadCrumb: `${currentAsset?.AssetName} >`,
          Routes: `${UrlPath.AssetDetails}${params.Asset}`,
        },
        {
          BreadCrumb: `Private Exposure`,
          Routes: `${UrlPath.PrivateExposure}${params.Asset}`,
        },
      ];

  const  previouslyActiveTab=locationData.state === null ? "Charts" : locationData.state.ActiveTab;

  return (
    <div>
      <TopBar label={"Private Exposure"} />
    
      <div  className="mainContentData">
      <BreadCrumbs Levels={Level} />
        <div class="p-4">

          <Tabs
            defaultActiveKey={previouslyActiveTab}
            id="uncontrolled-tab-example"
            className="ms-3"
            onSelect={(e)=>{setSelectedTab(e)}}
          >
            <Tab eventKey="Charts" title="Charts">
              <div className="p-3 bg-white life-science rounded">
              {selectedTab=="Charts" &&    <PrivateCharts />}
              </div>
            </Tab>
            <Tab eventKey="Data" title="Data">
              <div class="p-3 bg-white life-science rounded">
              {selectedTab=="Data" &&    <>
              <Data />
              </>}

              </div>
            </Tab>
            <Tab eventKey="Configuration" title="Configuration">
                  <div className="p-3 bg-white life-science rounded">
                    {selectedTab === "Configuration" && <Configuration />}
                  </div>
                </Tab>
            
                <Tab eventKey="Mapping" title="Mapping">
                  <div className="p-3 bg-white life-science rounded">
                    {selectedTab === "Mapping" && <Mapping/>}
                  </div>
                </Tab>
            
          </Tabs>
        </div>
      </div>    
      <ToastContainer/>
    </div>
  )
}